import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items, tone = "default" }: { items: Crumb[]; tone?: "default" | "onDark" }) {
  const wrapClass = tone === "onDark" ? "text-white/70" : "text-foreground-500";
  const linkClass = tone === "onDark" ? "hover:text-accent-400" : "hover:text-accent-600";
  const currentClass = tone === "onDark" ? "text-white" : "text-foreground-800";
  const sepClass = tone === "onDark" ? "text-white/40" : "text-foreground-300";

  return (
    <nav aria-label="面包屑导航" className={`flex flex-wrap items-center gap-1.5 text-sm ${wrapClass}`}>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className={`${linkClass} transition-colors whitespace-nowrap`}>
              {item.label}
            </Link>
          ) : (
            <span className={`${currentClass} whitespace-nowrap`}>{item.label}</span>
          )}
          {index < items.length - 1 && <span className={sepClass}>/</span>}
        </span>
      ))}
    </nav>
  );
}